import { render, staticRenderFns } from "./ChallengeHistory.vue?vue&type=template&id=e565abbe"
import script from "./ChallengeHistory.vue?vue&type=script&lang=js"
export * from "./ChallengeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports